import { makeStyles, styled } from "@mui/styles";
import React, { useEffect } from "react";
import { Box, CardActions, CardContent, Divider, Grid, TableCell, tableCellClasses, Typography } from "@mui/material";
import ApexCharts from "react-apexcharts";
import { useTranslation } from "react-i18next";
import cssVariables from "../../theme/cssVariables";
import planningImg from "../../assets/images/home/planning.svg";
import bannerBg from "../../assets/images/home/home-banner-bg.svg";

styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#163263',
    },
    [`&.${tableCellClasses.body}`]: {
        'border-width': 0,
        'padding-left': 0,
    },
}));
const styles = {
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        minHeight: 200,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
    },
    bannerImage: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        maxWidth: "336px",
        height: "auto",
    },
    blueBadge: {
        background: "rgb(186, 217, 87,0.15)",
        padding: "5px 12px",
        color: "#93AC41",
        // opacity: "0.15",
    },
    barLegend: {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#939393",
    }
};
const useStyles = makeStyles({
    media: {
        height: 200,
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    customCardSize: {
        height: 380,
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
});

export default function MyAchievements(props) {
    const { t } = useTranslation();
    const { chart, total } = props;
    const classes = useStyles();
    const [typeList, setTypeList] = React.useState([]);
    const [score, setScore] = React.useState(0);
    const [criterionScore, setCriterionScore] = React.useState([0]);
    const [colorBar, setColor] = React.useState([]);
    const [dataBarChart, setDataBarChart] = React.useState([]);

    const [chartOptions, setChartOptions] = React.useState({});

    useEffect(() => {
        setChartOptions(chart)
    }, [chart])

    return (
        <Box px={2} pt={1}>
            <CardContent className={classes.cardContentSize} sx={{ justifyContent: "flex-start", alignItems: "flex-start", padding: "10px 0" }} style={{ "padding-bottom": "0px" }}>
                <Box sx={{ width: "100%", position: "relative", "border-left": "1px solid #E5E5E5", }}>
                    <Box sx={{ display: "flex", "justify-content": "space-between" }}>
                        <Box sx={{ display: "flex", width: "295px" }} pl="25px" pr="10px">
                            <Typography fontSize={18} lineHeight="26.4px" fontWeight={500} color="#404349" sx={{ textAlign: "left", "white-space": "nowrap" }}>
                                { t("label.myAchievements") }
                            </Typography>
                            <Box ml="15px" sx={{ background: "rgba(93, 161, 150, 0.15)", width: "max-content", padding: "0 8px", "border-radius": "2px", height: "25px" }}>
                                <Typography fontSize={16} lineHeight="24px" fontWeight={500} color="#5DA196" sx={{ textAlign: "left" }}>
                                    {total}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", "flex-flow": "row wrap", width: "calc(100% - 295px)", "max-width": "max-content" }}>
                            {
                                chartOptions?.series?.length > 0 ? chartOptions?.series?.map((loRow, index) => (
                                    <Box key={index} display="flex" alignItems="center">
                                        <Box sx={{ width: "15px", height: "15px" }} mr="2.5">
                                            <div className="bar-legend-square" style={{ backgroundColor: chartOptions.options.colors[index] }}></div>
                                        </Box>
                                        <Box sx={{ width: "max-content", overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis" }} px="10px"><Typography variant="label" style={styles.barLegend} fontWeight={300}>
                                            {t(`label.${loRow.name}`)}
                                        </Typography></Box>
                                    </Box>
                                ))
                                    : null
                            }
                        </Box>
                    </Box>
                    {Object.keys(chartOptions).length > 0 &&
                        <Box
                            sx={{
                            ".apexcharts-tooltip-marker": { borderRadius: "2px" },
                            ".apexcharts-tooltip-y-group > span": {
                                fontWeight: "400",
                            },
                            ".apexcharts-tooltip": {
                                background: "#F7F7F7",
                                fontWeight: "400",
                            },
                            height: "240px",
                            ".apexcharts-legend-text": {
                                color: "#A3A3A3 !important",
                            },
                            ".apexcharts-text": {
                                color: "#A3A3A3 !important",
                                fill: "#A3A3A3  !important",
                            },
                            ".apexcharts-tooltip-title": {
                                background: "#5DA196 !important",
                                color: "#FFFFFF",
                                fontWeight: "400",
                            },
                            }}
                        >
                            <ApexCharts
                            options={chartOptions.options}
                            series={chartOptions.series}
                            type={chartOptions.options.chart.type}
                            height="100%"
                            ></ApexCharts>
                        </Box>
                    }
                </Box>
            </CardContent >
        </Box >
    )
}

